<template>
    <div>
        <v-app-bar density="compact" color="surface-variant">
            <v-btn @click="closeViewer">
                <span>閉じる</span>
            </v-btn>
        </v-app-bar>
        <loading :active="isLoading" :is-full-page="true" :lock-scroll="true" loader="dots" color="#0168b7"
            background-color="#ffffff" opacity="1" />
        <div v-show="!isLoading" :style="{backgroundColor:'#fff'}">
            <iframe :src="page_uri" frameborder="0" width="100%" :height="pageHeight"></iframe>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import Loading from 'vue3-loading-overlay';
import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';

export default {
    name: 'ContentViewer',
    components: {
        Loading
    },
    props: {},
    data: () => ({
        'isLoading': true,
        'htmlSource': '',
        'loadedCSSLinks': [],
        'loadedScripts': [],
        'promises': [],
        'page_uri': '',
        pageHeight: 500
    }),
    computed: {},
    created: async function() {

        let referrerUrl = this.$store.getters.referrerUrl
        console.log(`store.referrerUrl is ${referrerUrl}`)

        // 閉じるボタン用に、リファラーのURLをストアに保存する。すでに保存されている場合は上書きしない
        if (!referrerUrl){

            // リファラがある場合はリファラ
            if( this.$router.referrer.fullPath ){
                const previousUrl = this.$router.referrer.fullPath == '/' ? '/progressive' : this.$router.referrer.fullPath
                await this.$store.dispatch("setReferrerUrl", previousUrl)
                console.log(`set referrerUrl <= ${previousUrl}`)
            // リファラが無い => 直アクセスはルートへ
            }else{
                await this.$store.dispatch("setReferrerUrl", '/progressive')
                console.log(`set referrerUrl <= '/progressive'`)
            }
        }else{
            console.log(`store.referrerUrl is keeped => ${referrerUrl}`)
        }
    },
    async mounted() {
        try {

            this.pageHeight = window.innerHeight - 160;

            //リロードするとpage_uriがなくなるので、強制的に戻るを実行する
            if(!this.$route.query.page_uri) {
                throw new Error('ページの取得に失敗しました。urlが指定されていません。' );
            }

            const response = await fetch(this.$route.query.page_uri, {
                headers: {
                    'X-Client-From': 'SPA'
                }
            });

            if (!response.ok) {
                throw new Error(`ページの取得に失敗しました。url(${this.$route.query.page_uri}) status(${response.status}) text(${response.statusText})` );
            }

            this.page_uri = this.$route.query.page_uri + '?platform=ms_app';

            this.$nextTick(() => {
                this.isLoading = false;
            });

        } catch (error) {
            console.error(error)
            this.$router.go(-1)
        }
    },
    beforeUnmount() {
        this.unloadCSS()
        this.unloadScript()
    },
    methods: {
        async fetchContent(pageUri) {
            try {
                const res = await axios.get(pageUri)
                console.log(res);
                return res.data
            } catch (err) {
                console.log(err);
            }
        },
        removeElementById(docHtml, elementId) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(docHtml, 'text/html');
            const elementToRemove = doc.getElementById(elementId);
            if (elementToRemove) {
                elementToRemove.remove();
            }
            return doc.documentElement.outerHTML;
        },
        removeElementByName(docHtml, elementName) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(docHtml, 'text/html');

            const elements = doc.querySelectorAll(elementName);

            elements.forEach(elementToRemove => {
                elementToRemove.remove();
            })
            return doc.documentElement.outerHTML;
        },
        removeSpecificRuleFromHtmlContent(docHtml, selectorText) {

            const parser = new DOMParser();
            const doc = parser.parseFromString(docHtml, 'text/html');

            const styleElements = doc.querySelectorAll('style');

            styleElements.forEach(styleElement => {
                const sheet = styleElement.sheet;
                const rules = sheet.cssRules || sheet.rules;  // ブラウザの互換性のため

                for (let i = rules.length - 1; i >= 0; i--) {
                    if (rules[i].selectorText === selectorText) {
                        sheet.deleteRule(i);
                    }
                }
            });

            return doc.documentElement.outerHTML;
        },
        loadCSS(href) {
            const linkTag = document.createElement('link');
            linkTag.rel = 'stylesheet';
            linkTag.href = href;

            this.promises.push(new Promise((resolve, reject) => {
                linkTag.onload = resolve;
                linkTag.onerror = reject;
            }));

            document.head.appendChild(linkTag);
            this.loadedCSSLinks.push(linkTag);
        },
        loadScript(script) {

            const scriptTag = document.createElement('script');
            if (script.src) {
                scriptTag.src = script.src;
            } else {
                scriptTag.textContent = script.textContent;
            }

            this.promises.push(new Promise((resolve, reject) => {
                scriptTag.onload = resolve;
                scriptTag.onerror = reject;
            }));

            document.body.appendChild(scriptTag);
            this.loadedScripts.push(scriptTag);
        },
        unloadCSS() {
            this.loadedCSSLinks.forEach(link => {
                link.remove();
                console.log(`css unloaded ${link}`)
            });
            this.loadedCSSLinks = [];
        },
        unloadScript() {
            this.loadedScripts.forEach(script => {
                script.remove();
                console.log(`script unloaded ${script}`)
            });
            this.loadedScripts = [];
        },
        closeViewer: async function() {

            let referrerUrl = this.$store.getters.referrerUrl

            console.log(`referrerUrl store is ${referrerUrl}`)

            referrerUrl = referrerUrl ? referrerUrl : '/progressive'

            console.log(`referrerUrl is ${referrerUrl}`)

            await this.$store.dispatch("setReferrerUrl", '')
            this.$router.replace(referrerUrl)

            console.log(`replace referrerUrl => ${referrerUrl}`)
        }        
    }
}
</script>